import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";

import * as theme from "../theme";
import logo from "../assets/images/logo.png";
import cobrandLogo from "../assets/images/Logo_Original_WhiteBG.png";

const HeadLine = ({ phoneNumber, isCobrand }) => {
  const linkNumber = phoneNumber ? phoneNumber : "855-517-0091";

  const displayNumber = `(${linkNumber.slice(0, 3)}) ${linkNumber.slice(
    4,
    7
  )}-${linkNumber.slice(8, 12)}`;

  const callNow = () => {
    window.location.href = `tel:${linkNumber}`;
  };

  return (
    <React.Fragment>
      <HeadLineWrapper>
        <LogoArea>
          <HeadLogoContainer to="/">
            <HeadLogo src={logo} alt={"ratezip logo"} $isCobrand={isCobrand} />
          </HeadLogoContainer>
          {isCobrand && (
            <>
              <LogoDivider />
              <CobrandLogoImg src={cobrandLogo} alt={"ReverseReady logo"} />
            </>
          )}
        </LogoArea>
        <HeadRight onClick={callNow}>
          <PhoneBox $isCobrand={isCobrand}>
            <PhoneInTalkIcon />
            <p>
              Call Us <NumberBox>{displayNumber}</NumberBox>
            </p>
          </PhoneBox>
        </HeadRight>
      </HeadLineWrapper>
    </React.Fragment>
  );
};

// number box should not be displayed on mobile and tablet
const NumberBox = styled.span`
  display: none;
  @media (min-width: 700px) {
    display: inline-block;
  }
`;

const LogoArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  @media (max-width: ${theme.mobile}) {
    gap: 8px;
  }
`;

const LogoDivider = styled.div`
  width: 1px;
  height: 32px;
  background-color: #c4c4c4;
  flex-shrink: 0;
  @media (max-width: ${theme.mobile}) {
    height: 24px;
  }
`;

const CobrandLogoImg = styled.img`
  height: 36px;
  width: auto;
  @media (max-width: ${theme.tablet}) {
    height: 30px;
  }
  @media (max-width: ${theme.mobile}) {
    height: 22px;
  }
`;

const PhoneBox = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  border: 1px solid #c4c4c4;
  border-radius: 10px;
  padding: 10px 20px;
  p {
    font-family: "Inter";
    font-style: normal;
    font-weight: ${theme.font_weight};
    font-size: ${theme.font_size};
    line-height: 24px;
    cursor: pointer;
    margin: 0;
    padding: 0;
  }
  @media (max-width: ${theme.mobile}) {
    ${props => props.$isCobrand && `
      padding: 8px 12px;
      gap: 0;
      p { display: none; }
    `}
  }
`;

const HeadLineWrapper = styled(theme.section)`
  height: 80px;
  padding: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 200;
  position: relative;
  background-color: ${theme.white};

  .outer-block {
    display: block;
  }
  @media (max-width: ${theme.tablet}) {
    width: 100%;
    height: 72px;
    z-index: 1000;
    background-color: #ffff;
    top: 0px;
  }
  @media (max-width: ${theme.mobile}) {
    height: 56px;
    .outer-block {
      display: none;
    }
  }
`;

const HeadLogoContainer = styled(Link)`
  width: 174px;
  height: 48px;
  @media (max-width: ${theme.tablet}) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 145px;
    padding: 0px 0px 0px 64px;
  }
  @media (max-width: ${theme.mobile}) {
    width: 87px;
    padding-left: 24px;
  }
`;

const HeadLogo = styled.img`
  width: 100%;
  @media (max-width: ${theme.mobile}) {
    ${props => props.$isCobrand && `
      width: 70px;
    `}
  }
`;

const HeadRight = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: ${theme.tablet}) {
    padding: 0px 64px 0px 0px;
  }
  @media (max-width: ${theme.mobile}) {
    padding: 0px 24px 0px 0px;
  }
`;

// const MenuContainer = styled.div`
//   display: flex;
// `;

// const MenuItemContainer = styled.div`
//   padding: 16px;
//   @media (max-width: ${theme.tablet}) {
//     display: none;
//   }
// `;

// const MenuItemDropDownContainer = styled(MenuItemContainer)`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   background-color: ${theme.primary_light};
//   padding: 8px 0px;
//   position: relative;
//   z-index: 100;
//   @media (max-width: ${theme.tablet}) {
//     display: none;
//   }
// `;

// const MenuItemDropDownText = styled.p`
//   font-family: "Inter";
//   font-style: normal;
//   font-weight: 600;
//   font-style: normal;
//   font-weight: 400;
//   font-size: 14px;
//   line-height: 24px;
//   color: ${theme.white};
//   text-decoration: none;
//   cursor: pointer;
// `;

// const MenuItem = styled.a`
//   font-family: "Inter";
//   font-style: normal;
//   font-weight: 400;
//   font-style: normal;
//   font-weight: 400;
//   font-size: 16px;
//   line-height: 24px;
//   color: ${theme.black};
//   text-decoration: none;
//   cursor: pointer;
// `;

// const HamburgerMenuContainer = styled.div`
//   display: none;
//   @media (max-width: ${theme.tablet}) {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     width: 40px;
//   }
//   @media (max-width: ${theme.mobile}) {
//     width: 24px;
//     padding-right: 24px;
//   }
// `;

// const HamburgerMenu = styled.img`
//   width: 100%;
// `;

export default HeadLine;
